module.exports = __webpack_public_path__ + "files/17d2a7201078524bc5e050420d81fc21.png";